module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-6000-Classes-Inactive-b77e9e02ee259f91c8f93a772ee29905.png";